import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ClientService } from '../../../services/client.service';

declare var $: any;

@Component({
  selector: 'ngx-work-pet',
  templateUrl: './pet.component.html',
})
export class PetComponent implements OnInit {

  private _pet_no: number;
  private _client_no: number;
  info = true;
  physical = false;
  parameters = false;
  assoc = false;
  referred = false;
  financial = false;
  notes = false;
  documents = false

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public petService: PetService,
    public clientService: ClientService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {        
        if (message !== this.pet_no) {
          console.log(this.pet_no,message);
          this.pet_no = message;
          this.petService.getNotesByPetId(this.pet_no).then(() => { });
          this.client_no = this.clientService.current_client_no;
        }
      });
  }

  add() {
    $('#modalNewPetNote').modal('toggle')
  }

  edit(item) {
    this.petService.pet_note = item;
    $('#modalNewPetNote').modal('toggle')
  }

  ver(tipo: string) {
    this.info = tipo === 'info'
    this.physical = tipo === 'physical'
    this.petService.view_physical = tipo === 'physical'
    this.parameters = tipo === 'parameters'
    this.assoc = tipo === 'assoc'
    this.referred = tipo === 'referred'
    this.financial = tipo === 'financial'
    this.notes = tipo === 'notes'
    this.documents = tipo === 'documents'
  }
}
